// extracted by mini-css-extract-plugin
module.exports = {"control":"print-approved-sp_control__1AfHv","btnPrint":"print-approved-sp_btnPrint__3it_L"};